import React from 'react'
import PropTypes from 'prop-types'

export const ListItem = ({ children, className = '', ...other }) => (
  <div className={`list-item-box bg-light-hover py-2 px-3 mb-2 ${className} `} {...other} >
    {children}
  </div>
)

ListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

export default ListItem
